import { createIcon } from '../createIcon';

export const LessThanIconConfig = {
  name: 'LessThanIcon',
  height: 512,
  width: 384,
  svgPath: 'M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const LessThanIcon = createIcon(LessThanIconConfig);

export default LessThanIcon;